

const vuePermission = {}
vuePermission.install=Vue=>{
    Vue.directive('perm', {
        inserted: function (el, binding, vnode) {

          let permissions =   Vue.prototype.$store.get('permissions')
          const params = binding.value
          if (permissions.indexOf('all') >= 0) {

          } else if (permissions.indexOf(params)<0) {
            el.style.display="none"
          }
        }
    })
}
export default vuePermission



// WEBPACK FOOTER //
// ./src/directive/permissions.js